@if (groupsLinks.length) {
    <light-box [isBlockScroll]="true" (closeLightBox)="onCloseMenu.emit()" [isLightBoxOpen]="isMainMenuOpen" (click)="onCloseMenu.emit()">
        <section class="menu-container grid gap30">
            <header class="flex bet a-center">
                <smart-router-link link="/" [isRouterLink]="isAngularApp">
                    <span class="logo-link">
                        <yeshiva-logo></yeshiva-logo>
                    </span>
                </smart-router-link>
                <section>
                    <global-search [isFocus]="FocusSearch" [placeholder]="freeSearchStr"></global-search>
                </section>
            </header>
            <main-menu-link class="main-menu-link" [activeLocation]="activeLocation" [isAngularApp]="isAngularApp"> </main-menu-link>
            @if (isMainMenuOpen) {
                <ul class="group-link-list margin-main-container">
                    @for (group of groupsLinks; track group; let i = $index) {
                        <li [class]="'group-' + (i + 1)">
                            <section class="grid">
                                <ng-container *ngTemplateOutlet="smartLink; context: { btnLink: group.title, isTitle: true }"> </ng-container>
                                <ul class="grid">
                                    @for (btnLink of group.btnLinks; track btnLink) {
                                        <ng-container *ngTemplateOutlet="smartLink; context: { btnLink: btnLink }"></ng-container>
                                    }
                                </ul>
                            </section>
                        </li>
                    }
                    <!-- nihul staff entries (plain hebrew like all nihul-facing ui) - see _updateNihulEntries -->
                    @if (showNihulHome() || showNihulLogin()) {
                        <li class="nihul-group">
                            <section class="grid">
                                <span class="smart-link-content title-list">ניהול האתר</span>
                                <ul class="grid">
                                    @if (showNihulHome()) {
                                        <li>
                                            @if (isHeb) {
                                                <smart-router-link [link]="nihulHomeLink()" [isRouterLink]="isAngularApp">
                                                    <span class="smart-link-content opacity-hover-7">כניסה לניהול</span>
                                                </smart-router-link>
                                            } @else {
                                                <a [href]="nihulHref">
                                                    <span class="smart-link-content opacity-hover-7">כניסה לניהול</span>
                                                </a>
                                            }
                                        </li>
                                    }
                                    @if (showNihulLogin()) {
                                        <li>
                                            <button type="button" class="nihul-connect" (click)="openNihulLogin()">
                                                <span class="smart-link-content opacity-hover-7">התחברות לניהול</span>
                                            </button>
                                        </li>
                                    }
                                    @if (showNihulLogout()) {
                                        <li>
                                            <a href="/users/LogOff/">
                                                <span class="smart-link-content opacity-hover-7">התנתקות</span>
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </section>
                        </li>
                    }
                    @if (showThemeSwitch()) {
                        <li class="theme-group">
                            <theme-switch></theme-switch>
                        </li>
                    }
                </ul>
            }
        </section>
    </light-box>
}

<ng-template #smartLink let-btnLink="btnLink" let-isTitle="isTitle">
    @if (btnLink.isAngularPage) {
        <smart-router-link [link]="btnLink.link" [queryParams]="btnLink.queryParams" [isRouterLink]="isAngularApp">
            <ng-container *ngTemplateOutlet="smartLinkContent; context: { btnLink: btnLink, isTitle: isTitle }"> </ng-container>
        </smart-router-link>
    } @else {
        <a [href]="btnLink.link">
            <ng-container *ngTemplateOutlet="smartLinkContent; context: { btnLink: btnLink, isTitle: isTitle }"> </ng-container>
        </a>
    }
</ng-template>

<ng-template #smartLinkContent let-btnLink="btnLink" let-isTitle="isTitle">
    <span class="smart-link-content opacity-hover-7" [ngClass]="{ 'title-list': isTitle }">
        {{ btnLink.name }}
    </span>
</ng-template>
